import aderenciaBdgd from './aderencia-bdgd';
import aderenciaAis from './aderencia-ais';
import bpr from './bpr';
import coge from './coge';
import comparativoBdgdAis from './comparativo-bdgd-ais';
import conciliacoes from './conciliacoes';
import administracao from './administracao';
import descricaoUc from './descricao-uc';
import home from './home';
import kpisAderenciasBdgd from './kpis-aderencias-bdgd';
import login from './login';
import perfil from './perfil';
import powerUps from './power-ups';
import predicoesBaixas from './predicoes-baixas';
import rcp from './rcp';
import relatorios from './relatorios';
import validacaoAtributosMcpse from './validacao-atributos-mcpse';
import unitizacoesObras from './unitizacoes-obras';
import bancoPrecosCalculos from './banco-precos-calculos';
import movimentacaoBlindada from './movimentacao-blindada';
import simuladorBaixas from './simulador-baixas';
import arquivosDados from './arquivos-dados';
import gruposArquivos from './grupos-arquivos';
import dados from './dados';
import variacoesPrecoUnitario from './variacoes-preco-unitario';
import importacoesBdgd from './importacoes-bdgd';
import saneamentoVoc from './saneamento-voc';
import parametrosComCa from './parametrosComCa';
import relatoriosModelos from './relatorios-modelos';
import gruposRelatorios from './grupos-relatorios';
import validacoesSdi from './validacoes-sdi';
import RemovedorGeorreferenciado from './removedor-georreferenciado';
import logsAplicacao from './logs-aplicacao';
import indicesCOGE from './indicesCOGE';
import AtualizacaoIndice from './atualizacao-indices';
import modulosAneel from './modulos-aneel';
import joa from './joa';
import agendamentosAutomaticos from './agendamentosAutomaticos';
import analisesBancoPrecos from './analises-banco-precos';
import mapeamentos from './mapeamentos';
import importacoesDados from './importacoes-dados';
import importacoesSped from './importacoes-sped';
import bulldozerr from './bulldozerr';
import simulacoesLaudosIncrementais from './simulacoes-laudos-incrementais';
import projecaoBrr from './projecao-brr';
import validacaoBaixas from './validacao-baixas';
import cadernoServicos from './caderno-servicos';
import liquidacaoCji3 from './liquidacao-cji3';
import logUnitizacao from './log-unitizacao';
import aie from './aie';
import montagensAisIncrementais from './montagens-ais-incrementais';
import conformidadeObras from './conformidade-obras';

let routes = [];
routes = routes.concat(
  aderenciaAis,
  aderenciaBdgd,
  bpr,
  coge,
  comparativoBdgdAis,
  conciliacoes,
  administracao,
  descricaoUc,
  home,
  kpisAderenciasBdgd,
  login,
  perfil,
  powerUps,
  predicoesBaixas,
  rcp,
  relatorios,
  validacaoAtributosMcpse,
  unitizacoesObras,
  bancoPrecosCalculos,
  movimentacaoBlindada,
  simuladorBaixas,
  arquivosDados,
  gruposArquivos,
  dados,
  variacoesPrecoUnitario,
  importacoesBdgd,
  saneamentoVoc,
  parametrosComCa,
  relatoriosModelos,
  gruposRelatorios,
  validacoesSdi,
  RemovedorGeorreferenciado,
  logsAplicacao,
  indicesCOGE,
  AtualizacaoIndice,
  agendamentosAutomaticos,
  joa,
  modulosAneel,
  analisesBancoPrecos,
  mapeamentos,
  importacoesDados,
  importacoesSped,
  bulldozerr,
  simulacoesLaudosIncrementais,
  projecaoBrr,
  validacaoBaixas,
  cadernoServicos,
  liquidacaoCji3,
  logUnitizacao,
  aie,
  montagensAisIncrementais,
  conformidadeObras
);
routes.push({
  path: '*',
  component: () => import('@/views/pages/Index'),
  children: [
    {
      name: '404 Error',
      path: '',
      component: () => import('@/views/pages/Error')
    }
  ]
});
routes.push({
  path: '/404',
  component: () => import('@/views/pages/Index'),
  children: [
    {
      name: '_404 Error',
      path: '',
      component: () => import('@/views/pages/Error')
    }
  ]
});
export default routes;
